/*
 * Jira Ticket:
 * Created Date: Tue, 2nd Jun 2020, 10:48:15 am
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2020 The Distance
 */

import { convertBytes } from 'utils';

const onDropRejected = ({
  files,
  translate,
  notify,
  allowedFileTypes,
  maxFileSize,
}) => {
  const reasons = [];
  files.forEach(file => {
    if (file.size > maxFileSize) {
      reasons.push(
        translate('error.fileUpload.fileTooBig', {
          filename: file.name,
          maxSize: convertBytes(maxFileSize, 0),
        })
      );
    } else if (!allowedFileTypes.includes(file.type)) {
      reasons.push(
        translate('error.fileUpload.fileWrongType', {
          filename: file.name,
          allowedFileTypes,
        })
      );
    } else {
      reasons.push(
        translate('error.fileUpload.unknownRejection', {
          filename: file.name,
        })
      );
    }
  });
  return notify(reasons.join(', ').toString(), 'warning');
};

export default onDropRejected;
